import React from 'react';
import { useTranslation } from 'react-i18next';
import COMPUTER_IMG from '@/assets/images/computer_intro.png';
import DOCUMENT_IMG from '@/assets/images/document.png';
import DOCUMENTS_IMG from '@/assets/images/documents.png';
import { CREATOR, APPROVER } from '@/helpers/constants';
import styles from './DialogIntroSequence.module.scss';

const StepOne = ({ lang, role }) => {
  const { t } = useTranslation();
  const roleAbbr = role === CREATOR ? 'CR' : 'AP';

  return (
    <div className={styles.ManualIntro}>
      <h1 className={styles.WelcomeTitle}>{t('introPopups.welcome', { lng: lang })}</h1>
      <h4>{t('introPopups.firstContact', { lng: lang })}</h4>
      <div className={styles.SectionContainer}>
        <div className={styles.SectionItem}>
          <img className={styles.ImagesSection} src={COMPUTER_IMG} alt="Computer" />
          <h4>Dashboard |</h4>
        </div>
        <div className={styles.SectionItem}>
          <img className={styles.ImagesSection} src={DOCUMENT_IMG} alt="document" />
          <h4>{t('introPopups.CRequest', { lng: lang })} |</h4>
        </div>
        <div className={styles.SectionItem}>
          <img className={styles.ImagesSection} src={DOCUMENTS_IMG} alt="documents" />
          <h4>{t('introPopups.OverviewCRs', { lng: lang })}</h4>
        </div>
      </div>

      <div className={styles.BoxShading}>
        <h5 className={styles.BoxShadingText}>
          {t('introPopups.offerVideos', { lng: lang })}
          {' '}
&nbsp;
          <a
            className={styles.Link}
            href={`https://social.cloud.corpintra.net/groups/cart${lang === 'en' ? '-campaign-request-tool-en' : ''}/pages/training`}
            rel="noreferrer"
            target="_blank"
          >
            CaRT Training
          </a>
        </h5>
        <br />
        <h5 className={styles.BoxShadingText}>{t(`introPopups.recomendVideos${roleAbbr}`, { lng: lang })}</h5>
        <ol className={styles.ListOrdenated}>
          <li>
            {t(`introPopups.firstLinkRecomended${roleAbbr}`, { lng: lang })}
&nbsp;
            <a
              className={styles.Link}
              href={`https://social.cloud.corpintra.net/docs/DOC-${role === APPROVER ? '451036' : '451034'}`}
              rel="noreferrer"
              target="_blank"
            >
              {t('clickHere', { lng: lang })}
            </a>
          </li>
          <li>
            {t(`introPopups.secondLinkRecomended${roleAbbr}`, { lng: lang })}
&nbsp;
            <a
              className={styles.Link}
              href={`https://social.cloud.corpintra.net/docs/DOC-${role === APPROVER ? '451037' : '451035'}`}
              rel="noreferrer"
              target="_blank"
            >
              {t('clickHere', { lng: lang })}
            </a>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default StepOne;
